<ion-header>
  <ion-toolbar color="light">
    <ion-title>Betriebsauswahl</ion-title>
    <ion-buttons slot="primary">
      <ion-button size="large" fill="solid" color="primary" (click)="addNewEmployer()" >
        <ion-icon name="add-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content scrollY="true">

  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <!-- List all employers -->
  <ng-container *ngFor="let item of employers">
    <ng-container *ngTemplateOutlet="employer_select;context:{employer:item}"></ng-container>
  </ng-container>
  <!-- Template for the employer select button -->
  <ng-template let-item="employer" #employer_select>
    <ion-item button (click)="onSelectEmployer(item)" detail="false">
      <ion-icon *ngIf="item.type === 'ENT'" name="business-outline"></ion-icon>
      <ion-icon *ngIf="item.type === 'RET'" name="360"></ion-icon>
      <ion-label class="ion-text-wrap label" *ngIf="item.state === 'ACTIVE'">{{item.name}}</ion-label>
      <ion-label class="ion-text-wrap label" *ngIf="item.state !== 'ACTIVE'">{{item.name}} (inaktiv)</ion-label>
      <ion-icon name="checkmark-outline" *ngIf="selected?.id===item.id"></ion-icon>
    </ion-item>
  </ng-template>
  <!-- ENd of template -->
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="primary">
      <ion-button fill="solid" color="primary" (click)="onClickOk()">
        {{'CANCEL'|translate}}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
